import { Locales } from "i18n/country";
import { loadServerTranslations } from "../i18n/messages";
import TermsAndConditionsHub from "./[lang]/terms-conditions-hub";

export default TermsAndConditionsHub;

export const getStaticProps = async () => {
  const locale = Locales.USA;

  return {
    props: {
      locale,
      messages: await loadServerTranslations(locale, ["common", "page-terms-conditions-hub"]),
    },
    revalidate: 60,
  };
};
